import module from 'recursoshumanos/module.js'

const schema = {
  existe: 'boolean',
}

export class RecursosHumanosLotesIMSSExisteService {
  constructor ($http) {
    this.$http = $http
  }

  get (numeroLote) {
    return this.$http.get('/api/recursos_humanos/lotes_imss/existe', {
      params: {numero_lote: numeroLote},
      schema,
    })
  }
}

module.service('RecursosHumanosLotesIMSSExiste', RecursosHumanosLotesIMSSExisteService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/LotesIMSS/Existe.js